export default __webpack_public_path__ + "static/media/no-projects-found-table.5b8ac7aa.svg";